<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="60%"
    transition="dialog-transition"
  >
    <v-card v-if="currentStream">
      <v-toolbar>
        <!-- <v-img
          v-if="(selected_company_id == 60 && currentStream.stream_id == 4)"
          max-height="50"
          max-width="50"
          contain
          :src="require('@/assets/temp-live-tv-hardcoded.png')"
        />
        <v-img
          v-else
          max-height="50"
          max-width="50"
          contain
          :src="
            require('@/assets/' +
              DEFINES.streams_properties[currentStream.stream_id].logo_name)
          "
        /> -->
        <div>
          <div class="title">{{ DEFINES.streams_properties[currentStream.stream_id].name }}</div>
        </div>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('update:dialog', false)" icon dark>
          <v-icon color="error">$vuetify.icons.rms_close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-layout row wrap pa-4>
        <v-flex xs12 v-if="currentStream.type == DEFINES.DailyCo">
          <div class="subheading font-weight-bold font-italic error--text">
            {{ $t('screener.interactive.element.daily.co.meeting.dialog.box.message') }}
          </div>
        </v-flex>
        <v-flex xs12 lg8 md8>
          <!-- ZOOM Discontinued -->
          <v-card-text
            v-if="false && (currentStream.type == DEFINES.ZoomMeeting)"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.meeting_number')"
                name="stream_title"
                color="primary"
                :hint="$t('screener.save.form.zoom_meeting_no.no_space')"
                type="text"
                v-model="currentStream.meeting_number"
                @input="trimSpace"
              ></v-text-field>
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.meeting_password')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.meeting_password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.VimeoLiveStream"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
              <v-text-field
                id="stream_content"
                :label="$t('screener.save.form.stream_content')"
                name="stream_content"
                color="primary"
                type="text"
                v-model="currentStream.vimeo_live_id"
                :placeholder="$t('screener.save.stream_content.placeholder')"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.YoutubeLiveStream"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
              <v-text-field
                id="stream_content"
                :label="$t('screener.save.form.youtube.stream_content')"
                name="stream_content"
                color="primary"
                v-model="currentStream.content"
                type="text"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.LiveChat"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.VimeoChatStream"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.FacebookLiveStream"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                v-if="currentStream.type == DEFINES.FacebookLiveStream"
                id="stream_content"
                :label="$t('screener.save.form.facebook.stream_content')"
                name="stream_content"
                color="primary"
                v-model="currentStream.content"
                type="text"
              ></v-text-field>
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <!-- Jitsi Discontinued -->
          <v-card-text
            v-if="false && (currentStream.type == DEFINES.JitsiLiveStream)"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
              <v-text-field
                id="meeting_url"
                :label="$t('screener.save.form.jitsi.meeting_url')"
                placeholder="https://meet.jit.si/your_meeting_name"
                name="meeting_url"
                color="primary"
                v-model="currentStream.meeting_url"
                type="text"
              ></v-text-field>
              <div class="text-xs-center">
                 <v-btn outline color="success" @click="setJitsiLiveEmbedUrl">{{$t('screener.save.form.jitsi.generate_meeting_url')}}</v-btn>
              </div>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.WhereByMeeting"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
              <v-text-field
                id="meeting_url"
                :label="$t('screener.save.form.whereby.meeting_url')"
                placeholder="Where by meeting room url"
                name="meeting_url"
                color="primary"
                v-model="currentStream.meeting_url"
                type="text"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.DailyCo"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
              <v-text-field
                id="meeting_url"
                :label="$t('screener.save.form.dailyco.meeting_url')"
                placeholder="Daily.co meeting room url"
                name="meeting_url"
                color="primary"
                v-model="currentStream.meeting_url"
                type="text"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.LiveWebinar"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
              ></v-text-field>
              <v-text-field
                id="meeting_url"
                :label="$t('screener.save.form.whereby.meeting_url')"
                placeholder="Where by meeting room url"
                name="meeting_url"
                color="primary"
                v-model="currentStream.attendee_url"
                type="text"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.MediaStream"
            class="pa-4"
          >
            <v-form ref="form">
                <v-autocomplete
                  v-model="currentStream.selected_media_id"
                  :search-input.sync="media_autocomplete.payload.search"
                  @change="onMovieChange"
                  :items="films"
                  :label="$t('screener.stream.media.select_media')"
                  outline
                  item-value="id"
                  item-text="title"
                  :loading="media_autocomplete.loading"
                  @input.native="fetchFilms"
                >

                  <template v-slot:item="data">
                    <template>
                      <v-list-tile-avatar>
                        <img :src="data.item.thumburls">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title >
                          <span>{{data.item.title}}</span>

                          <span :class="[data.item.is_external_src ? ' red--text' : ' success--text','pl-2','pr-1','caption']">({{ DEFINES.FILM_STREAMING_SOURCES[data.item.is_external_src] }})</span>
                        </v-list-tile-title>
                        <!-- <v-list-tile-sub-title>{{data.item.description}}</v-list-tile-sub-title> -->
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon ripple :to="{name: 'Film',params: {
                          film_id: data.item.id
                        }}" target="_blank">
                          <v-icon color="grey lighten-1">$vuetify.icons.rms_media_link</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </template>
                  </template>
                </v-autocomplete>
                <v-text-field

                  id="streaming_url"
                  :label="$t('screener.save.form.stream.title')"
                  name="stream_title"
                  color="primary"
                  type="text"
                  outline
                  v-model="currentStream.title"
                ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text
            v-if="currentStream.type == DEFINES.iFrame"
            class="pa-4"
          >
            <v-form ref="form">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.title')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="currentStream.title"
                outline
              ></v-text-field>
              <v-textarea
                id="source_code"
                :label="$t('screener.save.form.iframe.source_code')"
                placeholder="Add iFrame source code here"
                name="source_code"
                color="primary"
                v-model="currentStream.source_code"
                outline
                type="text"
              ></v-textarea>
            </v-form>
          </v-card-text>
        </v-flex>
        <v-flex xs12 lg4 md4>
          <v-layout row wrap pa-4>
            <v-flex xs12>
              <v-btn
                v-if="!currentStream.active && currentStream.type == DEFINES.LiveChat"
                color="error"
                outline
                small
                @click="$emit('enableLiveChat', currentStream)"
                >{{ $t("screener.save.form.stream.live_on_air") }}</v-btn
              >
              <DownloadMsgs v-if="currentStream.type == DEFINES.LiveChat" />
              <!-- Force Live on Air -->
              <v-btn
                v-if="
                  !currentStream.active &&
                  currentStream.type != DEFINES.LiveChat
                "
                color="error"
                outline
                small
                @click="$emit('confirmForceStream', currentStream)"
              >
                <b>{{ $t("screener.save.form.stream.force_live_on_air") }}</b>
              </v-btn>
              <!-- Stop -->
              <v-btn
                v-if="currentStream.active"
                outline
                small
                @click="$emit('deactivate', currentStream)"
                >{{ $t("screener.save.form.stream.live_stop") }}</v-btn
              >
              <!-- Preview -->
              <v-btn
                color="success"
                outline
                small
                @click="$emit('showPreview', currentStream)"
                >{{ $t("rms.button.media_editor.preview") }}</v-btn
              >
              <!-- Save -->
              <v-btn color="secondary" small @click="$emit('saveStreams')">{{
                $t("rms.button.save")
              }}</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
import DEFINES from "@/defines";
import { mapGetters } from "vuex";
import { getJitsiLiveEmbedUrl } from "@/helper";
import DownloadMsgs from "@/components/screener/DownloadMsgs";
import { mapFields } from 'vuex-map-fields'
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    currentStream: {
      type: Object,
      default: null,
    }
  },
  components:{
    DownloadMsgs
  },
  name: "StreamConfigurationDialog",
  data() {
    return {
      media_autocomplete:{
        loading: false,
        payload: {
          search: '',
          page: 1,
          perPage: 100,
          isAutocomplete: true
        }
      }
    }
  },
  mounted() {
    this.fetchFilms();
  },
  methods: {
    trimSpace(value) {
      this.currentStream.meeting_number = value.replace(/\s/g, "");
    },
    setJitsiLiveEmbedUrl(){
     this.currentStream.meeting_url = getJitsiLiveEmbedUrl();
    },

    /**
     * Fetch streaming url of media
     */
    async onMovieChange(film_id){

      await this.$store.dispatch('film/getStreamingUrl',{
        film_id: film_id
      })
      .then((res) => {
        let film = this.$store.getters["film/getFilm"](film_id);
        this.currentStream.streaming_url = res.streaming_url;
        this.currentStream.subtitles = film.subtitles;
        this.currentStream.title = film.title;
      })
      .catch((error) => {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
        this.currentStream.streaming_url = null
      })
    },

    async fetchFilms() {
      this.media_autocomplete.loading = true
       await this.$store.dispatch("film/list",this.media_autocomplete.payload)
       .then((res)=> {
         //
       })
       .finally(() => {
         this.media_autocomplete.loading = false;
       });
    }
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
    }),
    ...mapFields("film", {
      films: "list"
    }),
    ...mapFields("company",{
      company: "company"
    }),
    movie: function () {
      return this.$store.getters["film/getMediasFromId"](
        this.DEFINES.MEDIA.FILM.SCREENERS
      );
    },
  }
};
</script>
